"use client";

import { useResponsive } from "@dafiti/closet-ui/hooks";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

import type { Facet } from "../types/filters.type";

type FilterListFacet = {
  facet: Facet;
  variant: "switch" | "drill";
};

export function useFilterList(facets: Facet[]) {
  const { isMobile } = useResponsive();
  const pathname = usePathname();

  const items = useMemo<FilterListFacet[]>(() => {
    const switchItems: FilterListFacet[] = [];
    const drillItems: FilterListFacet[] = [];
    const visibleFacets = facets.filter(
      (f) => !(f.field === "brand" && pathname.startsWith("/b/")),
    );

    for (const facet of visibleFacets) {
      const isBoolean =
        facet.component === "Default" && facet.selector === "Boolean";

      if (isBoolean) {
        if (isMobile) {
          switchItems.push({ facet, variant: "switch" });
        }
      } else {
        drillItems.push({ facet, variant: "drill" });
      }
    }

    switchItems.sort((a, b) => a.facet.order - b.facet.order);
    drillItems.sort((a, b) => a.facet.order - b.facet.order);

    return [...switchItems, ...drillItems];
  }, [facets, isMobile, pathname]);

  return { items };
}
